import { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useFileImports } from '@api/fileImports';
import { useCafs } from '@api/cafs';
import { useAuthorizedDocuments } from '@api/authorized_documents';
import { Title, Pagination, Group, Button, Table, Text, Paper, Badge } from '@mantine/core';
import { DOCUMENTTYPEOPTIONS } from '@constants';
import CreateFileImportModal from './create';
import TableComponent from './table';

const FileImportIndex = () => {
  const [activePage, setPage] = useState(1);
  const [openedCreateModal, { open: openCreateModal, close: closeCreateModal }] =
    useDisclosure(false);

  const { data: fileImports, isFetching } = useFileImports(activePage);
  const { data: cafs } = useCafs();
  const { data: authorized_documents } = useAuthorizedDocuments();

  // Create CAF table data
  const cafTableData = DOCUMENTTYPEOPTIONS.map((docType) => {
    const currentCaf = cafs?.data?.find((caf) => caf.dte_type === docType.number);
    const isAuthorized = authorized_documents?.data?.some((auth) => auth.dte_type === docType.number);
    
    return {
      documentType: docType.label,
      dteType: docType.number,
      leftToUse: currentCaf?.left_to_use || 0,
      isAuthorized,
      nextNumber: currentCaf?.next_number || '-',
    };
  }).filter((item) => item.isAuthorized); // Only show authorized documents

  const cafTableHeaders = [
    'Tipo de Documento',
    'Folios Restantes',
    'Próximo Número',
  ];

  const cafTableRows = cafTableData.map((item) => [
    item.documentType,
    <Badge 
      key="folios"
      color={item.leftToUse > 10 ? "green" : item.leftToUse > 0 ? "yellow" : "red"}
      variant="filled"
    >
      {item.leftToUse}
    </Badge>,
    item.nextNumber,
  ]);

  return (
    <>
      <Group justify="space-between" align="center" mb={20}>
        <Title order={1}>Carga Masiva DTEs</Title>
        <Button className="green-button" onClick={openCreateModal}>
          Cargar Archivo
        </Button>
      </Group>
      
      {/* CAF Table */}
      <Paper shadow="xs" p="md" mb={20}>
        <Text fw={600} mb={10} fz={16}>
          Folios Disponibles por Tipo de Documento
        </Text>
        <Table>
          <Table.Thead>
            <Table.Tr>
              {cafTableHeaders.map((header) => (
                <Table.Th key={header}>{header}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {cafTableRows.map((row, index) => (
              <Table.Tr key={index}>
                {row.map((cell, cellIndex) => (
                  <Table.Td key={cellIndex}>{cell}</Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Paper>

      <TableComponent data={fileImports?.data || []} isFetching={isFetching} />
      <div className="d-flex justify-content-center">
        <Pagination
          total={fileImports?.meta.pages || 1}
          value={activePage}
          onChange={setPage}
          mt="sm"
          pb={40}
        />
      </div>
      <CreateFileImportModal opened={openedCreateModal} close={closeCreateModal} />
    </>
  );
};

export default FileImportIndex;
